module.exports = __webpack_public_path__ + "static/media/whatsapp.a26e74f8.png";